import { styled } from '@mui/material/styles';
import { Paper, Checkbox, CircularProgress, Typography } from '@mui/material';

interface CheckBoxStyledProps {
  focus: boolean;
}

const PaperContainer = styled(Paper)(({ theme }) => ({
  width: '100%',
  objectFit: 'contain',
  display: 'flex',
  alignItems: 'center',
  color: theme.palette.primary.main,
  justifyContent: 'space-between',
  padding: '11 14 11 14',
}));

const CheckBoxStyled = styled(Checkbox, {
  shouldForwardProp: (prop) => prop !== 'focus',
})<CheckBoxStyledProps>(({ theme, focus }) => ({
  ...(focus && {
    color: theme.palette.error.main,
  }),
}));

const ATagStyled = styled('a')(({ theme }) => ({
  color: theme.palette.primary.main,
}));

const SpanStyled = styled('span')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  color: 'white',
});

const CircularLoaderDiv = styled(CircularProgress)({
  textAlign: 'center',
  margin: 26,
});

const ButtonDiv = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignContent: 'center',
  alignItems: 'center',
  width: '100%',
  zIndex: 2,
  margin: '12px 0px 12px 0px',
});

const LocalTypographyButton = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: 500,
  fontSize: '16px',
  lineHeight: '24px',
  letterSpacing: '0.15px',
});

const LocalCancelButton = styled('button')({
  borderRadius: '100px',
  padding: '8px 60px',
  cursor: 'pointer',
  transition: 'all 0.3s ease-in-out',
  color: '#414046',
  backgroundColor: 'transparent',
  border: 'none',
  marginBottom: '10px',
});

export {
  PaperContainer,
  CheckBoxStyled,
  ATagStyled,
  SpanStyled,
  CircularLoaderDiv,
  ButtonDiv,
  LocalTypographyButton,
  LocalCancelButton,
};
